import { latest as LatestVDETypes } from '@libs/waymark-video/video-descriptor-types';
import { Composition } from '../compositions';
import { ImageLayer } from './ImageLayer';
import { TextLayer } from './TextLayer';
import { FootageLayer } from './FootageLayer';
import { SubCompositionLayer } from './SubCompositionLayer';
import { ShapeLayer } from './ShapeLayer';
import { SolidLayer } from './SolidLayer';
import { AudioLayer } from './AudioLayer';
import { NullLayer } from './NullLayer';
import { UnsupportedLayer } from './UnsupportedLayer';

export const makeLayer = (layerData: LatestVDETypes.Layer, parentComposition: Composition) => {
  switch (layerData.ty) {
    case TextLayer.layerType:
      return new TextLayer(layerData, parentComposition);
    case ImageLayer.layerType:
      return new ImageLayer(layerData, parentComposition);
    case FootageLayer.layerType:
      return new FootageLayer(layerData, parentComposition);
    case SubCompositionLayer.layerType:
      return new SubCompositionLayer(layerData, parentComposition);
    case ShapeLayer.layerType:
      return new ShapeLayer(layerData, parentComposition);
    case SolidLayer.layerType:
      return new SolidLayer(layerData, parentComposition);
    case AudioLayer.layerType:
      return new AudioLayer(layerData, parentComposition);
    case NullLayer.layerType:
      return new NullLayer(layerData, parentComposition);
    default:
      return new UnsupportedLayer(layerData, parentComposition);
  }
};
